var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-5"},[_c('router-link',{staticClass:"background-color-seashell font-size-sm nav-button-border-radius pa-2",attrs:{"to":{ name: 'account', hash: _vm.getHash(_vm.textContent) }}},[_vm._v(" "+_vm._s(_vm.textContent)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }